<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="hidden">
  <section class="row bg-brown">
    <div class="col-lg-4 col-md-5 col-sm-12 pr-0">
      <div class="upload-progress-section ">
        <div class="text-center">
          <div>
            <img src="assets/images/adult.jpg" alt="" style="width: 100%;" />
          </div>
          <h2 class="text-white mt-3">
            “Good questions make readers think out of the Box.” <br />
            <b><em> ―QSL</em></b>
          </h2>
        </div>
        <div class="mt-auto container font14 text-grey">
          Goodlouck
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-7 col-sm-12 bg-white">
      <div class="container">
        <div class="my-5">
          <div class="question-box">
            <div class="d-flex justify-content-between">
              <div class="font16 text-green">
                Progress: {{ rightAnswerPercent | number:'1.0-0' }} %
                <div class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    aria-valuenow="70"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [style.width]="rightAnswerPercent + '%'"
                  ></div>
                </div>
              </div>
              <div class="px-3">
                <div class="font16 text-green">Result History</div>
                <button 
                    class="btn-sm btn-secondary"
                    data-toggle="modal" data-target="#resultModal">
                    Result
                  </button>
              </div>
            </div>
            <div class="mb-2 p-5">
              <p
                class="font24"
              >
                {{ questionIndex + 1 + " out of " + totalQuestions }}
              </p>
              <p class="mb-3 py-4 font24 text-grey click">
                <i class="fa fa-arrow-left" (click)="back()"></i> Quiz Title
              </p>
              <div class="my-4 question-body">
                <div class="d-flex align-items-center">
                  <div class="mr-3">
                    <p
                      class="font16 numspan "
                      [innerHTML]="questionIndex + 1"
                    ></p>
                  </div>
                  <div class="row w-100">
                    <div class="col-lg-12 col-sm-12">
                      <p
                        class="font16 quespan"
                        [innerHTML]="quizQuestions[questionIndex]?.title"
                      ></p>
                    </div>
                  </div>
                </div>
                <hr />
                <div
                  *ngFor="
                    let option of quizQuestions[questionIndex]?.answers;
                    index as j
                  "
                  class="my-4  radio-item"
                >
                  <input
                    class=""
                    #myInput
                    type="radio"
                    id="{{ questionIndex }}{{ j }}"
                    value="{{ option.id }}"
                    name="options{{ questionIndex }}"
                    [checked]="
                      checked(quizQuestions[questionIndex].id, myInput.value)
                    "
                  />
                  <label class="" for="{{ questionIndex }}{{ j }}">
                    {{ option.title }}</label
                  >
                </div>
                <span class="notClicked text-red"></span>
                <hr />
              </div>
              <div class="mt-5 pb-5 d-flex justify-content-between">
                <div *ngIf="questionIndex + 1 === quizQuestions['length']">
                  <button class="btn-sm btn-secondary" (click)="finish()">
                    Submit
                  </button>
                </div>

                <div
                  class="font18 text-green float-right"
                  *ngIf="questionIndex + 1 < quizQuestions['length']"
                >
                  <div class="click" (click)="next()">
                    Next <i class="fa fa-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>


<!--edit Modal -->
<div class="modal fade" id="resultModal" tabindex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title font18" id="resultModalLabel">
                  Overall Score
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body mx-auto p-5">
            <div class="text-center">
              <div
                class="font20 d-flex align-items-center m-auto"
                *ngIf="allScores?.length == 0"
                >
                  <img src="assets/icons/info.png" alt="" />
                  <div class="ml-3 text-green font-light">
                    You have not take any quiz yet
                  </div>
              </div>
              <div *ngFor="let list of allScores | paginate
              : {
                  id: 'quizResult',
                  itemsPerPage: paginationResultInfo?.size,
                  currentPage: paginationResultInfo?.number,
                  totalItems: paginationResultInfo?.totalElements
                };"
              >
                <div class="px-3">
                    <div
                      class="bg-grey border-radius my-3 p-3"
                    >
                      <div class="col-md-3 d-flex align-items-center">
                        <img
                          src="assets/images/menu-icon.png"
                          alt=""
                          class="mr-3"
                        />
                        <div>{{ list?.grade + '%' }}</div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-3 sm-flex-column">
              <pagination-controls
                id="quizResult"
                (pageChange)="navigatePage($event)"
              ></pagination-controls>
            </div>
          </div>
      </div>
  </div>
</div>
